import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import userQueries from "../../../requests/queries/userQuesries";
import "./auth.css";

export default function Login() {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await userQueries.login(formData.email, formData.password);
            window.location.href = '/projects';
        }catch{
            setError("Identifiants incorrects");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">🔐</div>
                <h1 className="auth-title">Bon retour !</h1>
                <p className="auth-subtitle">
                    Connectez-vous pour accéder à votre espace
                </p>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-input-group">
                        <label className="auth-label" htmlFor="email">
                            Adresse email
                        </label>
                        <input
                            id="email"
                            className="auth-input"
                            type="email"
                            name="email"
                            placeholder="vous@exemple.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="auth-input-group">
                        <label className="auth-label" htmlFor="password">
                            Mot de passe
                        </label>
                        <input
                            id="password"
                            className="auth-input"
                            type="password"
                            name="password"
                            placeholder="••••••••"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <button 
                        type="submit" 
                        className={`auth-button ${isLoading ? 'loading' : ''}`}
                        disabled={isLoading}
                    >
                        <span>Se connecter →</span>
                    </button>
                    {error && <div className="auth-error">{error}</div>}
                </form>

                <div className="auth-footer">
                    Pas encore de compte ?{" "}
                    <Link to="/register" className="auth-link">
                        Créer un compte
                    </Link>
                </div>
            </div>
        </div>
    );
}
